"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _utils = _interopRequireDefault(require("../utils"));

// Hook to return current device based on theme breakpoints
var useClientDevice = function useClientDevice() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  var _useState = (0, _react.useState)(null),
      device = _useState[0],
      setDevice = _useState[1];

  (0, _react.useEffect)(function () {
    var setterFunction = function setterFunction() {
      setDevice(_utils["default"].getClientDevice());
    }; // Add event listener


    if (typeof window !== "undefined") window.addEventListener("resize", setterFunction); // Call handler right away so state gets updated with initial window size

    setDevice(_utils["default"].getClientDevice()); // Remove event listener on cleanup

    return function () {
      window.removeEventListener("resize", setterFunction);
    };
  }, []); // Empty array ensures that effect is only run on mount

  return _utils["default"].getClientDevice();
};

var _default = useClientDevice;
exports["default"] = _default;